// | ------------------------------------------------------------------------
// | Dropdown On Hover
// | ------------------------------------------------------------------------

var dropdownMenu = function () {
  var windowWidth = document.body.clientWidth;
  var header = document.querySelector(".site-header");

  if (windowWidth > 767) {
    var navItem = document.querySelectorAll(".site-header .dropdown");
    var catItem = document.querySelectorAll(".tag-links .dropdown");

    for (var i = 0; i < navItem.length; i++) {
      navItem[i].onmouseenter = function () {
        this.classList.add("show");
        this.querySelector(".dropdown-toggle").setAttribute(
          "aria-expanded",
          "true"
        );
        this.querySelector(".dropdown-menu").classList.add("show");
        header.classList.add("menu-open");
      };
      navItem[i].onmouseleave = function () {
        this.classList.remove("show");
        this.querySelector(".dropdown-toggle").setAttribute(
          "aria-expanded",
          "false"
        );
        this.querySelector(".dropdown-menu").classList.remove("show");
        header.classList.remove("menu-open");
      };
    }
  }
};

// Run on scroll/load/resize
window.addEventListener("scroll", dropdownMenu, false);
window.addEventListener("load", dropdownMenu, false);
window.addEventListener("resize", dropdownMenu, false);
